<template>
    <section class="recover-password-container">
        <HeaderComponent :title="'Recuperar Senha'"></HeaderComponent>
        <h1>Olá, {{ getRecoverPasswordData.userName }}. Digite sua nova senha.</h1>
        <div class="recover-password">
            <div class="recover-password-data">
                <label for="senha" class="required">Nova Senha: </label>
                <input type="password" id="new-password" name="new-password" placeholder="Nova senha" v-model="newPassword"/>
            </div>
            <div class="recover-password-data">
                <label for="confirm-new-password" class="required">Confirme a senha: </label>
                <input type="password" id="confirm-new-password" name="confirm-new-password" placeholder="Confirme a Senha" @change="checkPassword()" v-model="confirmNewPassword"/>
            </div>
            <div class="recover-password-button" v-if="!loading">
                <ButtonCenter v-for="(but, bKey) in buttons" style="width: calc(100% - 30%);" :key="bKey" :button="but" @click="but.action && but.action()"></ButtonCenter>
            </div>
            <div v-else-if="loading" class="loading">
                <i class="fas fa-spinner fa-spin"></i>
            </div>
        </div>
        <ModalInfo @toLogin="toLogin"></ModalInfo>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { updatePasswordAfterRecover } from '@/components/controllers/LoginController.js'
import { showSuccessNotification, showErrorNotification, showAlertNotification } from '@/libs/Util.js'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
export default {
    name: 'RecoverPasswordView',
    components: {
        HeaderComponent,
        ButtonCenter,
        ModalInfo
    },
    data () {
        return {
            newPassword: '',
            confirmNewPassword: '',
            buttons: [
                {
                    display: 'Atualizar',
                    fill: true,
                    action: this.updateNewPassword
                }
            ],
            fields: [
                {
                    display: 'Senha atual',
                    placeholder: 'Senha',
                    type: 'password',
                    required: true
                },
                {
                    display: 'Nova senha',
                    placeholder: 'Nova senha',
                    type: 'password',
                    required: true
                },
                {
                    display: 'Confirmar nova senha',
                    placeholder: 'Confirmar a senha',
                    type: 'password',
                    required: true
                }
            ],
            loading: false
        }
    },
    computed: {
        ...mapGetters(['recoverPasswordMenu', 'getRecoverPasswordData'])
    },
    methods: {
        ...mapActions(['changeRecoverPasswordMenuVisibility']),
        ...mapActions(['showModalInfo']),

        getId: function (display) {
            return display.replaceAll(' ', '').toLowerCase()
        },
        updateNewPassword: function () {
            this.passwordError = ''
            const isValidPassword = this.checkPassword()
            if (isValidPassword) {
                this.loading = true
                updatePasswordAfterRecover(
                    this.getRecoverPasswordData.CDCLIENTE,
                    this.getRecoverPasswordData.NMLOGINCONS,
                    this.newPassword,
                    this.getRecoverPasswordData.CDCONSUMIDOR || null
                ).then((res) => {
                    this.loading = false
                    if (res.rowsAffected > 0) {
                        showSuccessNotification({
                            title: '',
                            text: 'Senha atualizada com sucesso!',
                            duration: 5000
                        })

                        this.$router.push('/')
                    } else {
                        showErrorNotification({
                            title: '',
                            text: 'Erro ao atualizar a senha. Tente novamente.'
                        })
                    }
                })
            }
        },
        toLogin: function () {
            this.$router.push('/')
        },
        checkPassword: function () {
            if (!this.newPassword || !this.confirmNewPassword) {
                showAlertNotification({
                    title: '',
                    text: 'Preencha todos os campos.'
                })
                return false
            }
            if (this.newPassword !== this.confirmNewPassword) {
                showAlertNotification({
                    title: '',
                    text: 'As senhas não conferem.'
                })
                return false
            }
            return true
        }
    }
}
</script>

<style lang="less" scoped>
.recover-password-container {
    .recover-password {
        margin-top: 10%;
        .recover-password-data{
            margin-bottom: 30px;
            label {
                display: block;
                position: relative;
                margin-bottom: 15px;
                &.required:after{
                    content: '*';
                    color: red;
                    margin-left: 5px;
                }
            }
            input:not([type="checkbox"]) {
                width: calc(100% - 20px);
                padding: 15px 10px;
                font-size: 16px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                border-radius: 7px;
                margin-top: 10px;
            }
        }
        .error-password {
            text-align: center;
            color: red;
        }
        .recover-password-button {
            margin-top: 40px;
        }
    }

    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 40px;
        i {
            font-size: 40px;
            color: var(--primaryColor);
        }
    }
}
</style>
